<template>
<div class="NewcomerSignInPopMarsk">
  <div class="PopBox">
    <img @click="close()" src="../../assets/images/account/close.png" alt="" class="close">
    <NewcomerSignIn @close="close()" :isClose="isClose" :VersionCData="VersionCData" channel="pop"/>
  </div>
</div>
</template>

<script>
import NewcomerSignIn from '../../components/NewcomerSignIn/index.vue'
export default {
  name: 'index',
  props: ['VersionCData'],
  components: {
    NewcomerSignIn
  },
  data () {
    return {
      isClose: false
    }
  },
  methods: {
    close () {
      this.isClose = true
      this.$emit('handleClose')
    }
  }
}
</script>

<style lang="less" scoped>
@keyframes popUpAnimation{
  0%{
    bottom: -100vw;
  }
  100%{
    bottom: 4vw;
  }
}
.NewcomerSignInPopMarsk{
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.7);
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .PopBox{
    margin-top: 40vw;
    position: relative;
    height: 154.722vw;
    width: 91.569vw;
    border-radius: 2vw;
    background-color: rgb(32,32,32);
    flex-shrink: -1;
    animation: popUpAnimation 0.2s ease-out forwards;
    .close{
      position: absolute;
      height: 4.7vw;
      width: 4.7vw;
      right: 0;
      top: -8vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewcomerSignInPop/index.vue